const AZURE_BLOB_HOST = 'stupaprodsguscentral.blob.core.windows.net';
const GCS_BUCKET_HOST = 'storage.googleapis.com/stupaprodsguscentral';

/**
 * Event card image URL: empty for missing / placeholder values (the API can send the literal
 * `'string'`), and Azure blob URLs pointed at the GCS bucket. Cards fall back to the original
 * URL when the rewritten one fails to load (see {@link hasImageUrlFallback}).
 */
export function eventImageUrl(raw: string | null | undefined, useOriginal = false): string {
  if (!raw || raw === 'string') return '';
  return useOriginal ? raw : raw.replace(AZURE_BLOB_HOST, GCS_BUCKET_HOST);
}

/** True when `raw` was rewritten, so retrying with the original URL is worthwhile. */
export function hasImageUrlFallback(raw: string | null | undefined): boolean {
  return !!raw && raw.includes(AZURE_BLOB_HOST);
}
